import { useEffect, useState } from 'react';

/**
 * URL temporária (`blob:`) para um arquivo escolhido no browser.
 *
 * Cria com `URL.createObjectURL` e **revoga** ao trocar de arquivo ou desmontar
 * — sem isso cada troca de imagem/vídeo vaza um blob na memória da aba. Devolve
 * `undefined` quando não há arquivo.
 *
 * @param file - Arquivo escolhido, ou `null`.
 *
 * @example
 * ```tsx
 * const previewUrl = useObjectUrl(imageFile);
 * ```
 */
export function useObjectUrl(file: File | null): string | undefined {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!file) {
      setUrl(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return url;
}
